import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import "./registerServiceWorker";
import { register } from 'register-service-worker'

// Import createI18n directly
import { createI18n } from "vue-i18n";

// Import translation files
import en from "./locales/en.json";
import my from "./locales/my.json";
import th from "./locales/th.json";
import zh from "./locales/zh.json";

const savedLang = localStorage.getItem("lang") || "en";

// Create i18n instance with proper configuration
const i18n = createI18n({
  legacy: false,
  locale: savedLang,
  fallbackLocale: "en",
  messages: {
    en,
    my,
    th,
    zh,
  },
  // Add runtime compilation for development
  runtimeOnly: false, // This is important!
});

// Initialize Pusher and Echo
window.Pusher = Pusher;
window.Echo = new Echo({
  broadcaster: "pusher",
  key: "b62d470a2a7aae868015",
  cluster: "ap1",
  forceTLS: false,
  encrypted: false,
  // authEndpoint: "http://127.0.0.1:8000/broadcasting/auth/",
  authEndpoint: "https://api.axefood.org/api/broadcasting/auth",
  auth: {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      Accept: "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  },
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then(registration => {
        console.log('ServiceWorker registered with scope:', registration.scope);
        
        // Check if service worker is controlling the page
        if (navigator.serviceWorker.controller) {
          console.log('Service worker is controlling the page');
        }
      })
      .catch(error => {
        console.log('ServiceWorker registration failed:', error);
      });
  });
}

if (process.env.NODE_ENV === 'production') {
  // Unregister any existing service workers first
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        if (registration.active?.scriptURL.includes('firebase-messaging-sw')) {
          console.log('Firebase SW already registered');
          return;
        }
      }
      
      // Register our custom service worker
      register('/firebase-messaging-sw.js', {
        registered(registration) {
          console.log('✅ Service worker registered:', registration);
        },
        error(error) {
          console.error('❌ Service worker registration error:', error);
        }
      });
    });
  }
}
const app = createApp(App);

app.use(store);
app.use(router);
app.use(Toast);
app.use(i18n);
app.mount("#app");
